import { render, staticRenderFns } from "./UserInvitation.vue?vue&type=template&id=ea27176c&"
import script from "./UserInvitation.vue?vue&type=script&lang=js&"
export * from "./UserInvitation.vue?vue&type=script&lang=js&"
import style0 from "./UserInvitation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports